var $ae2286b176a3af67$exports = {};
$ae2286b176a3af67$exports = {
    "collectionLabel": `Sugest\xf5es`
};


export {$ae2286b176a3af67$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
